// Check if app is installed as PWA
export const isPWAInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         (window.navigator as any).standalone ||
         document.referrer.includes('android-app://');
};

// Handle PWA installation
export const handleInstallPrompt = async (deferredPrompt: any) => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User ${outcome === 'accepted' ? 'accepted' : 'dismissed'} the install prompt`);
  }
};

// Update app height for mobile
export const updateAppHeight = () => {
  requestAnimationFrame(() => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  });
};

// Initialize PWA event listeners
export const initializePWA = () => {
  // Update height on resize and orientation change
  window.addEventListener('resize', updateAppHeight);
  window.addEventListener('orientationchange', () => {
    setTimeout(updateAppHeight, 100);
  });

  // Initial height update
  updateAppHeight();

  // Handle PWA installation
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    const deferredPrompt = e;
    // Store the event for later use
    (window as any).deferredPrompt = deferredPrompt;
  });
};